"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getInitials = function getInitials(name, maxChars) {
  return name.replace(/\s+/g, ' ').split(' ').slice(0, maxChars).reduce(function (acc, next) {
    return acc + next.charAt(0).toUpperCase();
  }, '');
};
var _default = getInitials;
exports["default"] = _default;